{
  "INAPP-1736.spotlight.body": [
    {
      "type": 0,
      "value": "We've got the basic settings for your integration covered. Customize them to make sure you get the most out of the integration."
    }
  ],
  "INAPP-1736.spotlight.primary": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "INAPP-1736.spotlight.secondary": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "INAPP-1736.spotlight.title": [
    {
      "type": 0,
      "value": "Set up your integration"
    }
  ],
  "INAPP-1737.spotlight.body": [
    {
      "type": 0,
      "value": "Draggable tags help you create well-defined alerts and manage them with ease. All you have to do is drag-and-drop the tags into any alert property field as needed"
    }
  ],
  "INAPP-1737.spotlight.primary": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "INAPP-1737.spotlight.secondary": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "INAPP-1737.spotlight.title": [
    {
      "type": 0,
      "value": "Create rich and informative alerts"
    }
  ],
  "alert.status.acked": [
    {
      "type": 0,
      "value": "Acknowledged"
    }
  ],
  "alert.status.closed": [
    {
      "type": 0,
      "value": "Closed"
    }
  ],
  "alert.status.open": [
    {
      "type": 0,
      "value": "Open"
    }
  ],
  "alert.status.snoozed": [
    {
      "type": 0,
      "value": "Snoozed"
    }
  ],
  "alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.created-at.no-translate": [
    {
      "type": 0,
      "value": "Created "
    },
    {
      "type": 1,
      "value": "createdAt"
    }
  ],
  "alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.description-label.no-translate": [
    {
      "type": 0,
      "value": "Note added"
    }
  ],
  "alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.id-label.no-translate": [
    {
      "type": 0,
      "value": "ID"
    }
  ],
  "alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.status-label.no-translate": [
    {
      "type": 0,
      "value": "Status"
    }
  ],
  "alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.tiny-id-label.no-translate": [
    {
      "type": 0,
      "value": "Tiny ID"
    }
  ],
  "alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-button.no-translate": [
    {
      "type": 0,
      "value": "View Alert"
    }
  ],
  "alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-compass-button.no-translate": [
    {
      "type": 0,
      "value": "View Alert in Compass"
    }
  ],
  "alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-jsm-button.no-translate": [
    {
      "type": 0,
      "value": "View Alert in Jira Service Management"
    }
  ],
  "alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-og-alert-button.no-translate": [
    {
      "type": 0,
      "value": "View alert in OpsGenie"
    }
  ],
  "alexstrasza.jsm-operations-add-note-to-alert.message-template.email.subject.no-translate": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " Note added to alert: ("
    },
    {
      "type": 1,
      "value": "priority"
    },
    {
      "type": 0,
      "value": ") "
    },
    {
      "type": 1,
      "value": "message"
    }
  ],
  "alexstrasza.jsm-operations-alert-acked.message-template.email.body.assignee-label.no-translate": [
    {
      "type": 0,
      "value": "Assignee"
    }
  ],
  "alexstrasza.jsm-operations-alert-acked.message-template.email.body.created-at.no-translate": [
    {
      "type": 0,
      "value": "Created "
    },
    {
      "type": 1,
      "value": "createdAt"
    }
  ],
  "alexstrasza.jsm-operations-alert-acked.message-template.email.body.description-label.no-translate": [
    {
      "type": 0,
      "value": "Description"
    }
  ],
  "alexstrasza.jsm-operations-alert-acked.message-template.email.body.id-label.no-translate": [
    {
      "type": 0,
      "value": "ID"
    }
  ],
  "alexstrasza.jsm-operations-alert-acked.message-template.email.body.integration-label.no-translate": [
    {
      "type": 0,
      "value": "Integration"
    }
  ],
  "alexstrasza.jsm-operations-alert-acked.message-template.email.body.responder-label.no-translate": [
    {
      "type": 0,
      "value": "Responder"
    }
  ],
  "alexstrasza.jsm-operations-alert-acked.message-template.email.body.source-label.no-translate": [
    {
      "type": 0,
      "value": "Source"
    }
  ],
  "alexstrasza.jsm-operations-alert-acked.message-template.email.body.status-label.no-translate": [
    {
      "type": 0,
      "value": "Status"
    }
  ],
  "alexstrasza.jsm-operations-alert-acked.message-template.email.body.tags-label.no-translate": [
    {
      "type": 0,
      "value": "Tags"
    }
  ],
  "alexstrasza.jsm-operations-alert-acked.message-template.email.body.tiny-id-label.no-translate": [
    {
      "type": 0,
      "value": "Tiny ID"
    }
  ],
  "alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-button.no-translate": [
    {
      "type": 0,
      "value": "View Alert"
    }
  ],
  "alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-compass-button.no-translate": [
    {
      "type": 0,
      "value": "View Alert in Compass"
    }
  ],
  "alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-jsm-button.no-translate": [
    {
      "type": 0,
      "value": "View Alert in Jira Service Management"
    }
  ],
  "alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-og-alert-button.no-translate": [
    {
      "type": 0,
      "value": "View in OpsGenie"
    }
  ],
  "alexstrasza.jsm-operations-alert-acked.message-template.email.subject.no-translate": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " Alert acknowledged: ("
    },
    {
      "type": 1,
      "value": "priority"
    },
    {
      "type": 0,
      "value": ") "
    },
    {
      "type": 1,
      "value": "message"
    }
  ],
  "alexstrasza.jsm-operations-alert-assigned.message-template.email.body.assignee-label.no-translate": [
    {
      "type": 0,
      "value": "Assignee"
    }
  ],
  "alexstrasza.jsm-operations-alert-assigned.message-template.email.body.created-at.no-translate": [
    {
      "type": 0,
      "value": "Created "
    },
    {
      "type": 1,
      "value": "createdAt"
    }
  ],
  "alexstrasza.jsm-operations-alert-assigned.message-template.email.body.description-label.no-translate": [
    {
      "type": 0,
      "value": "Description"
    }
  ],
  "alexstrasza.jsm-operations-alert-assigned.message-template.email.body.id-label.no-translate": [
    {
      "type": 0,
      "value": "ID"
    }
  ],
  "alexstrasza.jsm-operations-alert-assigned.message-template.email.body.integration-label.no-translate": [
    {
      "type": 0,
      "value": "Integration"
    }
  ],
  "alexstrasza.jsm-operations-alert-assigned.message-template.email.body.responder-label.no-translate": [
    {
      "type": 0,
      "value": "Responder"
    }
  ],
  "alexstrasza.jsm-operations-alert-assigned.message-template.email.body.source-label.no-translate": [
    {
      "type": 0,
      "value": "Source"
    }
  ],
  "alexstrasza.jsm-operations-alert-assigned.message-template.email.body.status-label.no-translate": [
    {
      "type": 0,
      "value": "Status"
    }
  ],
  "alexstrasza.jsm-operations-alert-assigned.message-template.email.body.tags-label.no-translate": [
    {
      "type": 0,
      "value": "Tags"
    }
  ],
  "alexstrasza.jsm-operations-alert-assigned.message-template.email.body.tiny-id-label.no-translate": [
    {
      "type": 0,
      "value": "Tiny ID"
    }
  ],
  "alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-button.no-translate": [
    {
      "type": 0,
      "value": "View Alert"
    }
  ],
  "alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-compass-button.no-translate": [
    {
      "type": 0,
      "value": "View Alert in Compass"
    }
  ],
  "alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-jsm-button.no-translate": [
    {
      "type": 0,
      "value": "View Alert in Jira Service Management"
    }
  ],
  "alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-og-alert-button.no-translate": [
    {
      "type": 0,
      "value": "View in OpsGenie"
    }
  ],
  "alexstrasza.jsm-operations-alert-assigned.message-template.email.subject.no-translate": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " Alert assigned: ("
    },
    {
      "type": 1,
      "value": "priority"
    },
    {
      "type": 0,
      "value": ") "
    },
    {
      "type": 1,
      "value": "message"
    }
  ],
  "alexstrasza.jsm-operations-alert-closed.message-template.email.body.assignee-label.no-translate": [
    {
      "type": 0,
      "value": "Assignee"
    }
  ],
  "alexstrasza.jsm-operations-alert-closed.message-template.email.body.created-at.no-translate": [
    {
      "type": 0,
      "value": "Created "
    },
    {
      "type": 1,
      "value": "createdAt"
    }
  ],
  "alexstrasza.jsm-operations-alert-closed.message-template.email.body.description-label.no-translate": [
    {
      "type": 0,
      "value": "Description"
    }
  ],
  "alexstrasza.jsm-operations-alert-closed.message-template.email.body.id-label.no-translate": [
    {
      "type": 0,
      "value": "ID"
    }
  ],
  "alexstrasza.jsm-operations-alert-closed.message-template.email.body.integration-label.no-translate": [
    {
      "type": 0,
      "value": "Integration"
    }
  ],
  "alexstrasza.jsm-operations-alert-closed.message-template.email.body.responder-label.no-translate": [
    {
      "type": 0,
      "value": "Responder"
    }
  ],
  "alexstrasza.jsm-operations-alert-closed.message-template.email.body.source-label.no-translate": [
    {
      "type": 0,
      "value": "Source"
    }
  ],
  "alexstrasza.jsm-operations-alert-closed.message-template.email.body.status-label.no-translate": [
    {
      "type": 0,
      "value": "Status"
    }
  ],
  "alexstrasza.jsm-operations-alert-closed.message-template.email.body.tags-label.no-translate": [
    {
      "type": 0,
      "value": "Tags"
    }
  ],
  "alexstrasza.jsm-operations-alert-closed.message-template.email.body.tiny-id-label.no-translate": [
    {
      "type": 0,
      "value": "Tiny ID"
    }
  ],
  "alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-button.no-translate": [
    {
      "type": 0,
      "value": "View Alert"
    }
  ],
  "alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-compass-button.no-translate": [
    {
      "type": 0,
      "value": "View Alert in Compass"
    }
  ],
  "alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-jsm-button.no-translate": [
    {
      "type": 0,
      "value": "View Alert in Jira Service Management"
    }
  ],
  "alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-og-alert-button.no-translate": [
    {
      "type": 0,
      "value": "View in OpsGenie"
    }
  ],
  "alexstrasza.jsm-operations-alert-closed.message-template.email.subject.no-translate": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " Alert closed: ("
    },
    {
      "type": 1,
      "value": "priority"
    },
    {
      "type": 0,
      "value": ") "
    },
    {
      "type": 1,
      "value": "message"
    }
  ],
  "alexstrasza.jsm-operations-alert-export.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Export Alert Result"
    }
  ],
  "alexstrasza.jsm-operations-alert-export.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "alexstrasza.jsm-operations-alert-export.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "We’ve exported your alerts and now you can download the zip file here:"
    }
  ],
  "alexstrasza.jsm-operations-alert-new.message-template.email.body.assignee-label.no-translate": [
    {
      "type": 0,
      "value": "Assignee"
    }
  ],
  "alexstrasza.jsm-operations-alert-new.message-template.email.body.created-at.no-translate": [
    {
      "type": 0,
      "value": "Created "
    },
    {
      "type": 1,
      "value": "createdAt"
    }
  ],
  "alexstrasza.jsm-operations-alert-new.message-template.email.body.description-label.no-translate": [
    {
      "type": 0,
      "value": "Description"
    }
  ],
  "alexstrasza.jsm-operations-alert-new.message-template.email.body.id-label.no-translate": [
    {
      "type": 0,
      "value": "ID"
    }
  ],
  "alexstrasza.jsm-operations-alert-new.message-template.email.body.integration-label.no-translate": [
    {
      "type": 0,
      "value": "Integration"
    }
  ],
  "alexstrasza.jsm-operations-alert-new.message-template.email.body.responder-label.no-translate": [
    {
      "type": 0,
      "value": "Responder"
    }
  ],
  "alexstrasza.jsm-operations-alert-new.message-template.email.body.source-label.no-translate": [
    {
      "type": 0,
      "value": "Source"
    }
  ],
  "alexstrasza.jsm-operations-alert-new.message-template.email.body.status-label.no-translate": [
    {
      "type": 0,
      "value": "Status"
    }
  ],
  "alexstrasza.jsm-operations-alert-new.message-template.email.body.tags-label.no-translate": [
    {
      "type": 0,
      "value": "Tags"
    }
  ],
  "alexstrasza.jsm-operations-alert-new.message-template.email.body.tiny-id-label.no-translate": [
    {
      "type": 0,
      "value": "Tiny ID"
    }
  ],
  "alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-button.no-translate": [
    {
      "type": 0,
      "value": "View Alert"
    }
  ],
  "alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-compass-button.no-translate": [
    {
      "type": 0,
      "value": "View Alert in Compass"
    }
  ],
  "alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-jsm-button.no-translate": [
    {
      "type": 0,
      "value": "View Alert in Jira Service Management"
    }
  ],
  "alexstrasza.jsm-operations-alert-new.message-template.email.body.view-og-alert-button.no-translate": [
    {
      "type": 0,
      "value": "View in OpsGenie"
    }
  ],
  "alexstrasza.jsm-operations-alert-new.message-template.email.subject.no-translate": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " New alert: ("
    },
    {
      "type": 1,
      "value": "priority"
    },
    {
      "type": 0,
      "value": ") "
    },
    {
      "type": 1,
      "value": "message"
    }
  ],
  "alexstrasza.jsm-operations-audit-log-download.message-template.email.body.download-button.no-translate": [
    {
      "type": 0,
      "value": "Download "
    },
    {
      "type": 1,
      "value": "exportType"
    },
    {
      "type": 0,
      "value": " log"
    }
  ],
  "alexstrasza.jsm-operations-audit-log-download.message-template.email.body.download-icon.alt.no-translate": [
    {
      "type": 0,
      "value": "Download icon"
    }
  ],
  "alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-category.no-translate": [
    {
      "type": 0,
      "value": "Category: "
    },
    {
      "type": 1,
      "value": "filterCategories"
    }
  ],
  "alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-label.no-translate": [
    {
      "type": 0,
      "value": "Export Criteria:"
    }
  ],
  "alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-log-level.no-translate": [
    {
      "type": 0,
      "value": "Log level: "
    },
    {
      "type": 1,
      "value": "filterLogLevels"
    }
  ],
  "alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-search.no-translate": [
    {
      "type": 0,
      "value": "Search: "
    },
    {
      "type": 1,
      "value": "searchKeywords"
    }
  ],
  "alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-time.no-translate": [
    {
      "type": 0,
      "value": "Time: "
    },
    {
      "type": 1,
      "value": "from"
    },
    {
      "type": 0,
      "value": " to "
    },
    {
      "type": 1,
      "value": "to"
    }
  ],
  "alexstrasza.jsm-operations-audit-log-download.message-template.email.body.greeting.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "userFullName"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "alexstrasza.jsm-operations-audit-log-download.message-template.email.body.heading.no-translate": [
    {
      "type": 0,
      "value": "Download your "
    },
    {
      "type": 1,
      "value": "exportType"
    },
    {
      "type": 0,
      "value": " log"
    }
  ],
  "alexstrasza.jsm-operations-audit-log-download.message-template.email.body.intro-message.no-translate": [
    {
      "type": 0,
      "value": "The CSV file for "
    },
    {
      "type": 1,
      "value": "siteName"
    },
    {
      "type": 0,
      "value": "'s "
    },
    {
      "type": 1,
      "value": "exportType"
    },
    {
      "type": 0,
      "value": " log is ready to download. The download link will expire in 24 hours."
    }
  ],
  "alexstrasza.jsm-operations-audit-log-download.message-template.email.body.limit-note.no-translate": [
    {
      "type": 0,
      "value": "Up to 100,000 activities can be exported at once, activities over the limit would be skipped in the CSV file."
    }
  ],
  "alexstrasza.jsm-operations-audit-log-download.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "exportType"
    },
    {
      "type": 0,
      "value": " log is ready to download"
    }
  ],
  "alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.affected-role-label.no-translate": [
    {
      "type": 0,
      "value": "Affected member role"
    }
  ],
  "alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.button-text.no-translate": [
    {
      "type": 0,
      "value": "View your alert notifications"
    }
  ],
  "alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.contact-methods.no-translate": [
    {
      "type": 0,
      "value": "contact methods"
    }
  ],
  "alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.description-label.no-translate": [
    {
      "type": 0,
      "value": "Description"
    }
  ],
  "alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.description-text.no-translate": [
    {
      "type": 0,
      "value": "The role-based notification "
    },
    {
      "type": 1,
      "value": "roleBasedNotificationSettingName"
    },
    {
      "type": 0,
      "value": " will trigger alert notifications based on the conditions set by the admin."
    }
  ],
  "alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.note-label.no-translate": [
    {
      "type": 0,
      "value": "Note"
    }
  ],
  "alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.note-text.no-translate": [
    {
      "type": 0,
      "value": "Review your "
    },
    {
      "type": 1,
      "value": "contactMethods"
    },
    {
      "type": 0,
      "value": " to confirm that this role-based notification works as expected."
    }
  ],
  "alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.override-message.no-translate": [
    {
      "type": 0,
      "value": "Role-based notifications override your personal notifications."
    }
  ],
  "alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.title.no-translate": [
    {
      "type": 0,
      "value": "Role-based notification turned on"
    }
  ],
  "alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Role-based notification turned on"
    }
  ],
  "alexstrasza.jsm-operations-rotation-ends.message-template.email.body.team.no-translate": [
    {
      "type": 0,
      "value": "Team"
    }
  ],
  "alexstrasza.jsm-operations-rotation-ends.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "["
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": "] Your on-call rotation in \""
    },
    {
      "type": 1,
      "value": "scheduleName"
    },
    {
      "type": 0,
      "value": "\" ends"
    }
  ],
  "alexstrasza.jsm-operations-rotation-ends.test-message.email.body.rotation-ending-at.no-translate": [
    {
      "type": 0,
      "value": "Your on-call rotation in \""
    },
    {
      "type": 1,
      "value": "scheduleName"
    },
    {
      "type": 0,
      "value": "\" is ending, at "
    },
    {
      "type": 1,
      "value": "endTime"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "alexstrasza.jsm-operations-rotation-ends.test-message.email.body.rotation-ending-now.no-translate": [
    {
      "type": 0,
      "value": "Your on-call rotation in \""
    },
    {
      "type": 1,
      "value": "scheduleName"
    },
    {
      "type": 0,
      "value": "\" is ending now."
    }
  ],
  "alexstrasza.jsm-operations-rotation-starts.message-template.email.body.app-store-logo.alt.no-translate": [
    {
      "type": 0,
      "value": "Download on the App Store"
    }
  ],
  "alexstrasza.jsm-operations-rotation-starts.message-template.email.body.manage-notifications.link-text.no-translate": [
    {
      "type": 0,
      "value": "update your notification settings"
    }
  ],
  "alexstrasza.jsm-operations-rotation-starts.message-template.email.body.manage-notifications.no-translate": [
    {
      "type": 0,
      "value": "To customize the email or unsubscribe, "
    },
    {
      "type": 1,
      "value": "link"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "alexstrasza.jsm-operations-rotation-starts.message-template.email.body.mobile-app.no-translate": [
    {
      "type": 0,
      "value": "Stay notified and comment on the go with Jira Service Management Mobile App"
    }
  ],
  "alexstrasza.jsm-operations-rotation-starts.message-template.email.body.play-store-logo.alt.no-translate": [
    {
      "type": 0,
      "value": "Download on the Play Store"
    }
  ],
  "alexstrasza.jsm-operations-rotation-starts.message-template.email.body.team.no-translate": [
    {
      "type": 0,
      "value": "Team"
    }
  ],
  "alexstrasza.jsm-operations-rotation-starts.message-template.email.footer-logo.alt.no-translate": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "alexstrasza.jsm-operations-rotation-starts.message-template.email.footer.privacy-policy.no-translate": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "alexstrasza.jsm-operations-rotation-starts.message-template.email.footer.text.no-translate": [
    {
      "type": 0,
      "value": "Sent to you by Atlassian Jira Service Management"
    }
  ],
  "alexstrasza.jsm-operations-rotation-starts.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "["
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": "] Your on-call rotation in \""
    },
    {
      "type": 1,
      "value": "scheduleName"
    },
    {
      "type": 0,
      "value": "\" starts"
    }
  ],
  "alexstrasza.jsm-operations-rotation-starts.test-message.email.body.rotation-starting-at.no-translate": [
    {
      "type": 0,
      "value": "Your on-call rotation in \""
    },
    {
      "type": 1,
      "value": "scheduleName"
    },
    {
      "type": 0,
      "value": "\" is starting, at "
    },
    {
      "type": 1,
      "value": "startTime"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "alexstrasza.jsm-operations-rotation-starts.test-message.email.body.rotation-starting-now.no-translate": [
    {
      "type": 0,
      "value": "Your on-call rotation in \""
    },
    {
      "type": 1,
      "value": "scheduleName"
    },
    {
      "type": 0,
      "value": "\" is starting now."
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.alert-feature-image.alt.no-translate": [
    {
      "type": 0,
      "value": "Alert management illustration"
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.chat-feature-image.alt.no-translate": [
    {
      "type": 0,
      "value": "Chat integration illustration"
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.explore-subheading.no-translate": [
    {
      "type": 0,
      "value": "Explore how operations can elevate your team's response"
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-alert-description.no-translate": [
    {
      "type": 0,
      "value": "Improve response efficiency and reduce the alert fatigue."
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-alert-title.no-translate": [
    {
      "type": 0,
      "value": "Manage all alerts in one place"
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-chat-description.no-translate": [
    {
      "type": 0,
      "value": "Handle alerts and on-call using your chat tools."
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-chat-title.no-translate": [
    {
      "type": 0,
      "value": "Respond to alerts via chat"
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-integration-description.no-translate": [
    {
      "type": 0,
      "value": "Connect your IT tools and apps to centralize alerts in one place."
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-integration-title.no-translate": [
    {
      "type": 0,
      "value": "Integrate with your apps"
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-oncall-description.no-translate": [
    {
      "type": 0,
      "value": "Set on-call schedules easily and never miss a critical alert."
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-oncall-title.no-translate": [
    {
      "type": 0,
      "value": "Become an on-call team"
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.heading.no-translate": [
    {
      "children": [
        {
          "type": 1,
          "value": "teamName"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " has launched its operations and is ready to respond"
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.integration-feature-image.alt.no-translate": [
    {
      "type": 0,
      "value": "Integration illustration"
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.launch-message.no-translate": [
    {
      "children": [
        {
          "type": 1,
          "value": "actorUserName"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " has launched "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "teamName"
        },
        {
          "type": 0,
          "value": "'s"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " operations and added you as a member to collaborate."
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.learn-more-link.no-translate": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.oncall-feature-image.alt.no-translate": [
    {
      "type": 0,
      "value": "On-call scheduling illustration"
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.start-collaborating-button.no-translate": [
    {
      "type": 0,
      "value": "Start collaborating"
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.team-image.alt.no-translate": [
    {
      "type": 0,
      "value": "Team profile picture"
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.body.what-are-operations.no-translate": [
    {
      "type": 0,
      "value": "What are operations?"
    }
  ],
  "alexstrasza.jsm-operations-team-enablement.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "You're invited to collaborate on your team's operations"
    }
  ],
  "alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.email-allowlist.no-translate": [
    {
      "type": 0,
      "value": "Your email server might be rejecting emails from Jira Service Management. Request your email administrator to allowlist jsm-notifications.atlassian.net."
    }
  ],
  "alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.email-deactivated.no-translate": [
    {
      "type": 0,
      "value": "The email address "
    },
    {
      "type": 1,
      "value": "displayName"
    },
    {
      "type": 0,
      "value": " you had added for alert notifications is deactivated."
    }
  ],
  "alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.email-reactivate.no-translate": [
    {
      "type": 0,
      "value": "If the email address is correct, go to the Alert notifications page in your personal settings and reactivate it."
    }
  ],
  "alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.greeting.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "fullName"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.mobile-deactivated.no-translate": [
    {
      "type": 0,
      "value": "The mobile device "
    },
    {
      "type": 1,
      "value": "displayName"
    },
    {
      "type": 0,
      "value": " added to your contact methods for mobile push notifications is currently deactivated because it's invalid or your app instance was unregistered. To continue receiving push notifications, re-install the application and verify the status from the Alert notifications page in your Jira personal settings."
    }
  ],
  "alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.phone-deactivated.no-translate": [
    {
      "type": 0,
      "value": "The phone number "
    },
    {
      "type": 1,
      "value": "displayName"
    },
    {
      "type": 0,
      "value": " added to your contact methods for voice/SMS is currently deactivated because it's invalid or it's blocklisted by your service provider. If the phone number is correct, go to the Alert notifications page in your Jira personal settings and reactivate it."
    }
  ],
  "alexstrasza.jsm-operations-user-contact-disabled.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "["
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": "] Contact method for notifications deactivated"
    }
  ],
  "alexstrasza.risk-assessment-spotlight.explore-categories.description": [
    {
      "type": 0,
      "value": "Rovo Ops breaks down risk into categories. Select any category to see risk details, contributing factors, and why it was flagged."
    }
  ],
  "alexstrasza.risk-assessment-spotlight.explore-categories.heading": [
    {
      "type": 0,
      "value": "Explore risk by category"
    }
  ],
  "alexstrasza.risk-assessment-spotlight.mitigate-risk.description": [
    {
      "type": 0,
      "value": "Get actionable mitigation steps tailored to each risk category, so you can address issues before the change goes live."
    }
  ],
  "alexstrasza.risk-assessment-spotlight.mitigate-risk.heading": [
    {
      "type": 0,
      "value": "Mitigate risk"
    }
  ],
  "alexstrasza.risk-assessment-spotlight.navigation.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "alexstrasza.risk-assessment-spotlight.navigation.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "alexstrasza.risk-assessment-spotlight.navigation.progress": [
    {
      "type": 1,
      "value": "currentStep"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "totalSteps"
    }
  ],
  "eoc-heartbeats.message-id.spotlight.body": [
    {
      "type": 0,
      "value": "Copy heartbeat’s name, edit, duplicate, and manage more heartbeat actions."
    }
  ],
  "eoc-heartbeats.message-id.spotlight.dismiss": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "eoc-heartbeats.message-id.spotlight.title": [
    {
      "type": 0,
      "value": "Easy access to heartbeat actions"
    }
  ],
  "eoc-heartbeats.tour.learn-more.no-translate": [
    {
      "type": 0,
      "value": "Learn More"
    }
  ]
}